//import React from 'react'
//import { Outlet, Link, NavLink } from "react-router-dom";
//import { useState, useEffect } from "react"
import "98.css";

export default function OEOTD() {

    return (
        <>

        <p>Breathing the last of the solstice air<br></br>
        Spinning a yarn with a white rabbit<br></br>
        Changing our clothes and we cut our hair<br></br>
        Just another disguise and a bad habit<br></br>
        <br></br>
        Said I don’t wanna be your<br></br>
        Said I don’t wanna be your kind<br></br>
        When you went back<br></br>
        I wasn’t right<br></br>
        Nothing to prove but a greater divided<br></br>
        <br></br>
        And I had one eye on the door<br></br>
        Looking back<br></br>
        <br></br>
        If you sold me, down the river<br></br>
        Would you stay with me, if a while<br></br>
        If you saw me<br></br>
        <br></br>
        Building a shrine of everything I know<br></br>
        Just to gamble its worth in impulse, sex and gold<br></br>
        Perfecting the art of being wise to foe<br></br>
        Just to fall in love with everyday Stockholm syndrome<br></br>
        I’m not always were my body is<br></br>
        In a world that don’t embody<br></br>
        It's the great dancing girl who used to fly in the trapeze<br></br>
        They cancelled her passion, she’s swinging in the breeze in her head<br></br>
        <br></br>
        Said I don’t wanna be your<br></br>
        Said I don’t wanna be your kind<br></br>
        When you went back<br></br>
        I wasn’t right<br></br>
        Nothing to prove but a greater divided<br></br>
        <br></br>
        And I had one eye on the door<br></br>
        Looking back<br></br>
        <br></br>
        If you sold me, down the river<br></br>
        Would you stay with me, if a while<br></br>
        If you saw me<br></br>
        <br></br>
        Ever since I joined this cult<br></br>
        Devoted to rituals<br></br>
        That ease our minds but don’t ease our souls<br></br>
        Live a life subliminal<br></br>
        Even when I think I’ve got control<br></br>
        The things I do for love and money make me lose it all<br></br>
        so I had one eye on the door<br></br>
        <br></br>
        Ever since I joined this cult<br></br>
        Devoted to rituals<br></br>
        That ease our minds but don’t ease our souls<br></br>
        Live a life subliminal<br></br>
        Even when I think I’ve got control<br></br>
        The things I do for love and money make me lose it all<br></br>
        so I had one eye on the door</p>
        
        </> 
    )
}